/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboZpusobOdesilani;
(function (EnumZboZpusobOdesilani) {
    EnumZboZpusobOdesilani["AIS"] = "AIS";
    EnumZboZpusobOdesilani["PODATELNA"] = "PODATELNA";
    EnumZboZpusobOdesilani["DS"] = "DS";
})(EnumZboZpusobOdesilani || (EnumZboZpusobOdesilani = {}));
//# sourceMappingURL=enum-zbo-zpusob-odesilani.js.map